
import UpdatesSource from "@/components/v2/updates-card/updates-source.vue";
import UpdatesContent from "@/components/v2/updates-card/updates-content.vue";
import ProfileActions from "@/components/v2/common/profiles/profile-actions.vue";

import { mapActions } from "vuex";

export default {
  components: {
    UpdatesSource,
    UpdatesContent,
    ProfileActions,
  },

  props: {
    newsItem: {
      type: Object,
      required: true,
    },
    showSource: {
      type: Boolean,
      default: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    showPohileHistoryLink: {
      type: Boolean,
      default: true,
    },
    /**
     * If true, add Show more/less button if long text for:
     * - About me updates,
     * - review
     */
    foldable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inFavorites: false,
      isFavoriteProcessing: false,
    };
  },

  mounted() {
    this.inFavorites = this.newsItem.profile.isFavorite;
  },

  methods: {
    ...mapActions({
      addToFafourites: "profiles/addToFafourites",
      removeFromFavourites: "profiles/removeFromFavourites",
    }),

    async processFavorite(profile) {
      console.log("processFavorite");

      if (this.newsItem.profile?.id != profile.id) return;
      if (this.$auth.loggedIn) {
        this.isFavoriteProcessing = true;
        let response;
        if (this.newsItem.profile.isFavorite) {
          response = await this.removeFromFavourites(this.newsItem.profile.id);
        } else {
          response = await this.addToFafourites(this.newsItem.profile.id);
        }

        if (response.data.status) {
          this.$store.commit("updates/setFavorite", this.newsItem);
          this.inFavorites = !this.inFavorites;
        }

        if (!response.data.status) {
          this.$notify({
            type: "warning",
            message: response.data.msg,
          });
        }
        this.isFavoriteProcessing = false;
      } else if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },
  },
};
